import React from "react";
import { SpaceImage } from "../../data/occupancy.api";
import { Splide, SplideSlide } from "@splidejs/react-splide";
// Default theme
import "@splidejs/react-splide/css";
import { Badge, Image } from "@chakra-ui/react";
import moment from "moment";

type Props = {
  images: SpaceImage[];
};

const SpaceSlideShow = ({ images }: Props) => {
  return images.length > 0 ? (
    <Splide options={{ height: 250, autoHeight: false }}>
      {images.map((image) => (
        <SplideSlide key={image.id} style={{ position: "relative" }}>
          <Badge
            position="absolute"
            top={5}
            left={5}
            _dark={{ bg: "gray.900" }}
          >
            Uploaded by {image.authorName}
          </Badge>
          <Badge
            position="absolute"
            top={5}
            right={5}
            _dark={{ bg: "gray.900" }}
          >
            {moment(image.submittedTimeUTC).format("DD/MM/YYYY")}
          </Badge>
          <Image
            w="full"
            h="full"
            objectFit="cover"
            objectPosition="center"
            src={image.url}
            alt="Location preview"
          />
        </SplideSlide>
      ))}
    </Splide>
  ) : null;
};

export default SpaceSlideShow;
